import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { COACH_NUDGES } from "@/data/content";
import { Sparkles, TrendingUp, Flame, Target } from "lucide-react";

const toneIcon = { opportunity: TrendingUp, streak: Flame, goal: Target };

export const AICoach = () => {
  return (
    <section id="ai-coach" data-testid="ai-coach" className="relative overflow-hidden bg-charcoal-deep py-24 sm:py-32">
      {/* dark spotlight mesh */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-0 h-96 w-96 rounded-full bg-gold/10 blur-[120px]" />
        <div className="absolute right-0 top-40 h-96 w-96 rounded-full bg-gold-rose/10 blur-[120px]" />
      </div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-gold">
              <Sparkles className="h-3.5 w-3.5" /> AI Gold Coach
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.1] tracking-tight text-ivory sm:text-5xl">
              A quiet voice that keeps your gold <span className="italic text-gold-gradient">growing</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-ivory/70">
              Not another dashboard to check. Shreedhan Coach watches the market and your goals,
              then nudges you at exactly the right moment — like a wise elder who happens to know finance.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-8 flex gap-8">
              {[["1.8x", "faster to goal"], ["+14%", "more saved / yr"], ["24/7", "market watch"]].map(([n, l]) => (
                <div key={l}>
                  <p className="font-serif text-3xl text-gold-gradient">{n}</p>
                  <p className="mt-1 text-sm text-ivory/60">{l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        {/* chat bubbles */}
        <div className="space-y-5">
          {COACH_NUDGES.map((n, i) => {
            const Icon = toneIcon[n.tone];
            return (
              <motion.div
                key={i}
                data-testid={`coach-nudge-${i}`}
                initial={{ opacity: 0, y: 24, x: 12 }}
                whileInView={{ opacity: 1, y: 0, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.18, ease: [0.22, 1, 0.36, 1] }}
                className="flex items-start gap-4 rounded-3xl rounded-tl-lg border border-white/10 bg-white/[0.06] p-5 backdrop-blur-md"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-gold to-gold-amber">
                  <Icon className="h-5 w-5 text-charcoal-deep" />
                </span>
                <div>
                  <p className="text-[13px] font-semibold uppercase tracking-wider text-gold">Shreedhan Coach</p>
                  <p className="mt-1 leading-relaxed text-ivory/90">{n.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
